import { AddressType } from "sats-connect";


export const UnisatWallet = 'unisat'

export const OKXWallet = 'okxwallet'

export const SafnectWallet = 'safnectwallet'


export interface AddressItem {
  address: string;
  addressType: AddressType;
  publicKey: string;
}

export interface ConnectedAccount {
  payment: AddressItem,
  ordinals?: AddressItem,
}

export interface WalletConnector {
}
